import { useState } from 'react';
import { Sparkles, X } from 'lucide-react';

const STORAGE_KEY = 'b2b_demo_banner_dismissed_v1';

/**
 * Soft amber/accent strip that sits on top of detail screens for is_demo=true
 * entities. Explains what the data is and how to engage with it. Dismissible
 * once per browser (localStorage); doesn't reappear after dismissal.
 *
 * Render conditionally where `entity.is_demo === true`.
 */
export default function DemoBanner({ children }) {
  const [dismissed, setDismissed] = useState(
    () => typeof window !== 'undefined' && localStorage.getItem(STORAGE_KEY) === '1'
  );

  if (dismissed) return null;

  const handleDismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* localStorage may be blocked in incognito; banner just won't persist */
    }
    setDismissed(true);
  };

  return (
    <div
      role="note"
      className="rounded-2xl border border-accent/30 bg-accent/5 px-4 py-3 flex items-start gap-3"
    >
      <Sparkles className="w-5 h-5 text-accent shrink-0 mt-0.5" aria-hidden="true" />
      <div className="flex-1 text-sm leading-relaxed text-ink-1">
        {children || (
          <>
            <strong>This is sample data</strong> we added to your workspace so you can explore Jobskills. Try sending a screening, or delete it when you're ready to add your own.
          </>
        )}
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Dismiss demo banner"
        className="text-ink-3 hover:text-ink-1 p-1 -m-1 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
      >
        <X className="w-4 h-4" aria-hidden="true" />
      </button>
    </div>
  );
}
